import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router";
import Table from "../../components/common/table/Table";
import Title from "../../components/common/title/Title";
import Button from "../../components/common/button/Button";
import { deleteApi, getApi } from "../../services/api/globalApi";
import { fileUrl } from "../../services/config";
import ShowImageModal from "../../components/common/modals/show-image-modal/ShowImageModal";
import Pagination from "../../components/common/pagination/Pagination";
import { errorMessage, successMessage } from "../../utils/toastify-message/ToastifyMessage";
import { fileListColumns } from "../../constant/tablesColumns/tablesColums";

const ITEMS_PER_PAGE = 10;

export default function FileList() {
  const [fileData, setFileData] = useState([]);
  const [pagination, setPagination] = useState(null);
  const [filter, setFilter] = useState({});
  const [imagePath, setImagePath] = useState("");
  const [searchQuery, setSearchQuery] = useState("");

  const imageRef = useRef();
  const navigate = useNavigate();

  const getFiles = async (params = {}) => {
    const path = `${fileUrl}files`;
    try {
      const response = await getApi({ path, params });
      const files = response?.data?.files || [];
      let filtered = files.filter(
        (item) => !(item.name.startsWith("medium") || item.name.startsWith("thumb"))
      );
      
      if (searchQuery) {
        filtered = filtered.filter((item) =>
          item.name.toLowerCase().includes(searchQuery.toLowerCase())
        );
      }
      
      const page = params.page || 1;
      const totalPages = Math.ceil(filtered.length / ITEMS_PER_PAGE);
      const start = (page - 1) * ITEMS_PER_PAGE;
      const paginatedFiles = filtered.slice(start, start + ITEMS_PER_PAGE);
      
      setFileData(paginatedFiles);
      setPagination({
        page,
        totalPages,
        hasNextPage: page < totalPages,
        hasPrevPage: page > 1,
        nextPage: page + 1,
        prevPage: page - 1,
        total: filtered.length,
      });
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getFiles(filter);
  }, [searchQuery]);

  const filterDataHandler = (newParams) => {
    const allFilter = { ...filter, ...newParams };
    setFilter(allFilter);
    getFiles(allFilter);
  };

  const handleDelete = async (item) => {
    if (!window.confirm(`آیا از حذف "${item.name}" مطمئن هستید؟`)) return;
    try {
      const path = `${fileUrl}files/${item.name}`;
      await deleteApi({ path });
      successMessage("فایل با موفقیت حذف شد");
      getFiles(filter);
    } catch (error) {
      errorMessage("خطا در حذف فایل");
      console.log(error);
    }
  };

  const showImage = (item) => {
    setImagePath(item.name);
    imageRef.current.showModal();
  };

  const clearImagePath = () => {
    setImagePath(null);
  };

  const data = fileData?.map((item) => ({
    ...item,
    key: item.name,
    id: item.name,
    showImage: (
      <div className="w-12 h-12 rounded-lg bg-gray-100 dark:bg-gray-700 flex items-center justify-center overflow-hidden border border-gray-200 dark:border-gray-600">
        <img
          className="w-full h-full object-cover"
          src={`${fileUrl}files/thumb_${item.name}`}
          loading="lazy"
          onError={(e) => {
            e.target.style.display = "none";
            e.target.parentElement.innerHTML = '<span class="text-lg">📄</span>';
          }}
          alt=""
        />
      </div>
    ),
  }));

  return (
    <div className="bg-white dark:bg-gray-900 rounded-3xl p-6">
      <div className="flex justify-between items-center mb-6 gap-4">
        <Title title={"لیست فایل ها"} />
        <Button
          onClick={() => navigate("/file")}
          text="آپلود فایل"
          color="success"
          type="button"
          className="whitespace-nowrap min-w-fit"
        />
      </div>

      <div className="mb-4">
        <div className="relative w-full sm:w-80">
          <input
            type="search"
            value={searchQuery}
            onChange={(e) => {
              setSearchQuery(e.target.value);
              setFilter({ ...filter, page: 1 });
            }}
            className="bg-white text-right border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full ps-10 p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            placeholder="جستجو فایل..."
          />
          <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
            <svg className="w-4 h-4 text-gray-500 dark:text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
            </svg>
          </div>
        </div>
      </div>

      <ShowImageModal
        ref={imageRef}
        imagePath={imagePath}
        clearImagePath={clearImagePath}
      />

      <Pagination pagination={pagination} filterDataHandler={filterDataHandler} />
      
      <Table
        columns={fileListColumns}
        rows={data}
        onDelete={handleDelete}
        onCustomFunction={showImage}
        customFunctionName="نمایش"
        notFoundMessage="فایلی یافت نشد"
      />

      <Pagination pagination={pagination} filterDataHandler={filterDataHandler} />
    </div>
  );
}
